import React from 'react';
import { parseHTML } from '@@utils/utils.ts';
import { TAliasModule } from '@@config/wcs/';

// Import component-scoped CSS (CSS Modules)
import * as styles from './InfoCard.module.css';

type TCardProps = {
    readonly data: TAliasModule;
};

const InfoCard: React.FC<TCardProps> = ({ data }) => {
    const { DESCRIPTION, IMAGE, TITLE } = data;

    return (
        <div className='my-4 lg:my-0'>
            <div className='card info-card border-0 p-2 lg:p-6'>
                <div className='flex justify-center sm:justify-start'>
                    {IMAGE && <img className={styles['cardIcon']} src={IMAGE.SRC} alt={IMAGE.ALT_TEXT} />}
                </div>
                <div className='card-body p-0'>
                    <h5 className={`${styles['cardTitle']} card-title text-center uppercase sm:text-left`}>{TITLE}</h5>
                    <p className='card-text text-center sm:text-left'>{parseHTML(DESCRIPTION)}</p>
                </div>
            </div>
        </div>
    );
};

export type { TCardProps };
export default InfoCard;
